/* eslint-disable no-unused-vars */
export const PrimapageForm = ({ data = {} }) => {
    return <></>;
};
